"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOktonTheme = exports.OKTON_THEME_KEY = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
exports.OKTON_THEME_KEY = "@okton:platform:theme";
function readInitialTheme() {
    var _a;
    if (typeof window === "undefined")
        return "light";
    try {
        const saved = window.localStorage.getItem(exports.OKTON_THEME_KEY);
        if (saved === "light" || saved === "dark")
            return saved;
    }
    catch (_b) { }
    return ((_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-color-scheme: dark)").matches)
        ? "dark"
        : "light";
}
function applyDocumentTheme(theme) {
    if (typeof document === "undefined")
        return;
    document.documentElement.classList.toggle("dark", theme === "dark");
    document.documentElement.dataset.oktonTheme = theme;
    document.documentElement.style.colorScheme = theme;
}
function persistTheme(theme) {
    try {
        window.localStorage.setItem(exports.OKTON_THEME_KEY, theme);
    }
    catch (_a) { }
}
function useOktonTheme() {
    const { colorMode, setColorMode } = (0, react_1.useColorMode)();
    const initialized = react_2.default.useRef(false);
    const theme = colorMode === "dark" ? "dark" : "light";
    react_2.default.useEffect(() => {
        if (initialized.current)
            return;
        initialized.current = true;
        const initialTheme = readInitialTheme();
        if (initialTheme !== colorMode) {
            setColorMode(initialTheme);
            applyDocumentTheme(initialTheme);
            persistTheme(initialTheme);
        }
    }, [colorMode, setColorMode]);
    react_2.default.useEffect(() => {
        applyDocumentTheme(theme);
        persistTheme(theme);
    }, [theme]);
    const setTheme = react_2.default.useCallback((nextTheme) => {
        setColorMode(nextTheme);
        applyDocumentTheme(nextTheme);
        persistTheme(nextTheme);
    }, [setColorMode]);
    const toggleTheme = react_2.default.useCallback(() => {
        setTheme(theme === "dark" ? "light" : "dark");
    }, [setTheme, theme]);
    return { theme, setTheme, toggleTheme };
}
exports.useOktonTheme = useOktonTheme;
//# sourceMappingURL=useOktonTheme.js.map